<template>
  <fn-page-container>
    <fn-store-listing :page="page" />
  </fn-page-container>
</template>

<script setup lang="ts">
definePageMeta({
  name: 'store-listing',
  routeCmsPage: (route) => route.path,
});

const nuxtApp = useNuxtApp();
const mainStore = useMainStore();
const route = useRoute();
const page = await mainStore.loadRoutePage(route);

nuxtApp.runWithContext(() => usePageMeta({ page }));
</script>
